module.exports = __webpack_public_path__ + "static/media/sweatcoin_wordmark.f93c965f.svg";